<ng-container *transloco="let t">
  @let currency = data.currency;
  @let locale = data.locale;
  <div class="flex max-h-[70vh] flex-col">
    @if (sections.length) {
      <div class="mb-4 flex justify-end">
        <app-export-button (export)="exportCsv()" />
      </div>
    }
    <div class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto">
      @for (section of sections; track section.titleKey) {
        <section>
          <div class="type-body-medium text-foreground mb-4">{{ t(section.titleKey) }}</div>
          <table iTable>
            <thead iTableHead>
              <tr>
                <th iTableTh>{{ t(section.nameColumnKey) }}</th>
                <th iTableTh>{{ t("common.marketplace") }}</th>
                <th iTableTh class="text-right">{{ t("billable-ad-spend-detail-modal.total_ad_spend") }}</th>
                <th iTableTh class="text-right">
                  {{ t("billable-ad-spend-detail-modal.ad_spend_fee") }}
                  @if (section.feeRate) {
                    ({{ section.feeRate | percent: "1.0-2" : locale }})
                  }
                </th>
              </tr>
            </thead>
            <tbody iTableBody>
              @for (row of section.rows; track $index) {
                <tr iTableRow>
                  <td iTableTd>{{ row.name }}</td>
                  <td iTableTd>{{ row.marketplace }}</td>
                  <td iTableTd class="text-right">
                    {{ row.adSpend | currency: currency : "symbol" : "1.2-2" : locale }}
                  </td>
                  <td iTableTd class="text-right">
                    {{ row.adSpendFee | currency: currency : "symbol" : "1.2-2" : locale }}
                  </td>
                </tr>
              }
              <tr iTableRow class="border-t border-gray-100">
                <td iTableTd colspan="2">{{ t("billable-ad-spend-detail-modal.subtotal") }}</td>
                <td iTableTd class="text-right">
                  {{ section.adSpendSubtotal | currency: currency : "symbol" : "1.2-2" : locale }}
                </td>
                <td iTableTd class="text-right">
                  {{ section.adSpendFeeSubtotal | currency: currency : "symbol" : "1.2-2" : locale }}
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      } @empty {
        <div class="text-muted-foreground py-4 text-center text-sm">{{ t("common.none") }}</div>
      }
    </div>

    <div class="text-foreground mt-4 flex justify-between border-t border-gray-200 px-3.5 pt-4 font-semibold">
      <div>{{ t("common.total") }}</div>
      <div>{{ total | currency: currency : "symbol" : "1.2-2" : locale }}</div>
    </div>
  </div>
</ng-container>
